import { useListUsersByOrganization } from 'api/resource';
import { User } from 'interfaces';
import { useMemo } from 'react';
import { useCurrentSiteStore } from 'store/SiteStore';
import { getUserFullName } from 'hooks/useGetUsersDisplayInfo';

const hasUploadModifyPermission = (user: User) => {
  const permissions = user.role?.permissions || [];
  return permissions.some(
    (permission) =>
      permission.resource === 'uploads' && permission.action === 'modify'
  );
};

export const useAssignableUploadUsers = () => {
  const { organizationID } = useCurrentSiteStore();
  const orgUsersResult = useListUsersByOrganization({ orgID: organizationID });

  const assignableUsers = useMemo(() => {
    const orgUsers = orgUsersResult.data || [];
    return orgUsers
      .filter((user) => user.status !== 'disabled')
      .filter(hasUploadModifyPermission)
      .sort((a, b) => getUserFullName(a).localeCompare(getUserFullName(b)));
  }, [orgUsersResult.data]);

  return {
    users: assignableUsers,
    isLoading: orgUsersResult.isLoading,
    isFetching: orgUsersResult.isFetching,
    isError: orgUsersResult.isError,
    errorMessage: orgUsersResult.error?.message || '',
  };
};
